<template>
  <section class="layout">
    <AppBar class="header" />
    <NavigationDrawer />
    <v-main class="main">
      <!--            <BreadcrumbVuetify />-->
      <BreadcrumbCustom :data="paths" language="en" />
      <v-card class="ma-2 pages-layout overflow-auto">
        <transitionPage>
          <router-view :key="$route.path" />
        </transitionPage>
      </v-card>
    </v-main>
  </section>
</template>
<script>
import AppBar from "./AppBar/index";
import NavigationDrawer from "./NavigationDrawer/index";
import transitionPage from "@/components/TransitionPage/index";
import BreadcrumbCustom from "@/components/Panel/Layout/Breadcrumb/BreadcrumbCustom/index";
// import store from "@/store";
// import BreadcrumbVuetify from "@/components/Panel/Layout/Breadcrumb/BreadcrumbVuetify/index";
// import BreadcrumbCustom from "vue-breadcrumb-dynamic";
// import { authService } from "@/services";
// import { mapGetters } from "vuex";

export default {
  name: "panel-layout",
  components: { AppBar, NavigationDrawer, transitionPage, BreadcrumbCustom },
  // async beforeRouteEnter(to, from, next) {
  //   if (!store.getters["userInfo/GET_USERINFO"].userStatus) {
  //     await store.dispatch("userInfo/ACTION_USERINFO");
  //     next();
  //   } else {
  //     next();
  //   }
  // },
  data() {
    return {
      paths: {
        "/panel": { en: "Panel" },
        "/panel/transactions": { en: "Transactions" },
        "/panel/transactions/?/?": { en: "-" },
        "/panel/businesses": { en: "Businesses" },
        "/panel/businesses/businesses-list": { en: "Businesses-list" },
        "/panel/businesses/businesses-list/?": { en: "-" },
        "/panel/businesses/businesses-list/?/gateways": { en: "Gateways" },
        "/panel/businesses/businesses-list/?/gateways/?": { en: "-" },
        "/panel/users": { en: "Users" },
        "/panel/users/?": { en: "-" },
        "/panel/pos-management": { en: "Pos-management" },
        "/panel/pos-management/pos-gateways": { en: "Pos-gateways" },
        "/panel/pos-management/?": { en: "-" },
        "/panel/currency-management": { en: "Currency-management" },
        "/panel/currency-management/list": { en: "List" },
        "/panel/currency-management/add-currency": { en: "Add-currency" },
        "/panel/currency-management/?": { en: "-" },
        "/panel/admin-management": { en: "Admin-management" },
        "/panel/admin-management/roles": { en: "Roles" },
        "/panel/admin-management/roles/add-role": { en: "Add-role" },
        "/panel/admin-management/roles/?": { en: "-" },
        "/panel/admin-management/admin-list": { en: "Admin-list" },
        "/panel/admin-management/admin-list/?": { en: "-" }
      }
    };
  }
  // computed: {
  //   ...mapGetters({
  //     userInfo: "userInfo/GET_USERINFO",
  //   }),
  // },
  // mounted() {
  //   if (!Object.keys(this.userInfo).length) {
  //     this.userInfoSubmission();
  //     // authService
  //     //   .userInfo()
  //     //   .then(response => {
  //     //     this.userInfoSubmission(response.data.data);
  //     //   })
  //     //   .catch(() => {
  //     //     this.$router.replace({ name: "loginForm" });
  //     //   });
  //   }
  // },
  // methods: {
  //   ...mapActions({
  //     userInfoSubmission: "userInfo/ACTION_USERINFO",
  //   }),
  // },
};
</script>
<style lang="scss">
@import "Layout";
</style>
